import React, { useEffect } from 'react';
import logo from '../../images/logo.png';
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import { logActivity } from '../../api';



const About = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "About Page",
  });
  const isAuth = !!localStorage.getItem("token"); // or your existing auth logic

  useEffect(() => {
    logActivity("Visit About Us Page", "Page Visit", null, isAuth);
  }, []);
  return (
    <>
      <Helmet>
        ‍<title>من نحن - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="من نحن - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div
        className="w-screen px-4 flex items-center flex-col mt-10 font-semibold text-lg"
        dir="rtl"
      >
        <img src={logo} alt="" className="w-20" />
        <div className="h-20" />
        <span>منصة محصول؟</span>
        <div className="h-5" />
        <span>
          {" "}
          انشئت منصة محصول والتي تم تنفيذها تحت وصاية شركة ACTS لتقنيات
          الحاسوب والاتصالات
        </span>
        <span>
          المتقدمة, وهي منصة متخصصة في تسويق وترويج الحاصلات الزراعية
          السودانية من كل انحاء السودان
        </span>
        <span>
          في مكان واحد وتربط المنتجين والتجار والمشترين من خلال العرض والطلب
          علي المنتجات والسلع,{" "}
        </span>
        <span>
          بجانب اصحاب الانشطة المتصلة مباشرة او غير مباشرة بالانتاج الزراعي
          والحاصلات المختلفة بهدف{" "}
        </span>
        <span>
          الربط المتكامل لسلاسل الامداد وتوفير وتسخير وتسهيل الوصول العادل
          للمعلومات والخدمات المتعلقة
        </span>
        <span>
          بالانتاج الزراعي ومعاملاته من مختلف مدن السودان, اضافة لنشرات متجددة
          ودورية للارشاد والتثقيف
        </span>
        <span>
          الزراعي حتي تتهيأ المساحة ليستقر الانتاج الزراعي ومن ثم الدفع بعجلة
          الاقتصاد الزراعي للاستقرار
        </span>
        <span>والاستدامة وينعكس علي الاقتصاد الوطني ليتعافي ويستقر.</span>
        <span>
          بشكل اساسي (محصول) يوفر معرضا للانتاج الزراعي في مناطق الانتاج و
          اسواق المحاصيل المنتشرة في{" "}
        </span>
        <span>
          كل بقاع السودان في شكل (بورصة رقمية) يستطيع من خلالها كل من المنتج
          (المزارع) والتجار والوسطاء
        </span>
        <span>
          والمشترين والمستهلكين من التعرف علي كمية ونوع المحاصيل المتداولة
          بشكل يومي و اسبوعي و شهري
        </span>
        <span>
          و سنوي, هذا بجانب الفرصة المتاحة لمزودي الخدمات (النقل, التخزين,
          الفرز, التعبئة والتغليف) من عرض
        </span>
        <span>
          ما لديهم من خدمات تسهل تداول المنتجات الزراعية وتحافظ عليها في نفس
          جودتها مما يخلق استدامة
        </span>
        <span>
          للامداد عبر التنافس العادل لتجويد ما يقدم من خدمات, ولمواد خام
          المعاملات الزراعية نصيب في هذه
        </span>
        <span>
          المنصة اذ تعرض الموجود فعليا من المعدات والادوات والمواد الخام
          وبتفاصيل اكثر تحديدا لنوع ودرجة
        </span>
        <span>
          جودة هذه المواد واماكن تواجدها بل وحتي كمياتها و امكانية توفير
          المطلوب منها.
        </span>
      </div>
    </>
  );
}

export default About